import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { InvoicesListPage } from '../../../features/sales/invoices-list-page'
import { invoiceSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/invoices/')({
  validateSearch: invoiceSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: InvoicesListPage,
})
